export default {
    ACCEPTED_TRADE: 'Вы согласились на сделку.',
    ACCEPTED_TRADE_OTHER: 'Другой игрок принял сделку.',
    ALREADY_HAVE_PET: 'У вас уже есть домашнее животное.',
    BLACK_POTION: 'Вы выпиваете черное зелье и начинаете чувствовать себя плохо.',
    CANNOT_ADD_ITEMS_TRADE: 'Вы не можете больше добавлять товары в сделку.',
    CANNOT_ATTACK_CHEATER: 'Этот игрок - мошенник, не стоит нападать на такого человека',
    CANNOT_ATTACK_CHEATER_SELF:
        'Извините, но читеры не могут атаковать других игроков, это было бы нечестно по отношению к ним!',
    CANNOT_ATTACK_MOB: 'У вас нет причин нападать на этих существ.',
    CANNOT_ATTACK_PET: 'Вы сошли с ума? Вызвать санитаров? Почему вы напали на домашнее животное?',
    CANNOT_ATTACK_PREY: 'Вы не можете атаковать, пока являетесь добычей.',
    CANNOT_ATTACK_TARGET: 'Вы не можете атаковать того, кто не является вашей целью.',
    CANNOT_ATTACK_LEVEL_DIFF:
        'Вы не можете атаковать того, кто находится более чем на 30 уровней выше или ниже вас.',
    CANNOT_DO_THAT: 'Вы не можете сделать это прямо сейчас.',
    CANNOT_DROP_ITEM_DOOR: 'Вы не можете бросить этот предмет, стоя в дверях.',
    CANNOT_PASS_DOOR: 'Через эту дверь нельзя пройти.',
    CANNOT_PICK_UP_ITEM: 'Этот предмет может забрать только {{username}}.',
    CANNOT_TALK: 'Сейчас вы не можете говорить.',
    CANNOT_TRADE_ITEM: 'Вы не можете обменять этот предмет.',
    CANNOT_TRADE_CHEATER: 'Извините, но мошенники к торговле не допускаются.',
    CANNOT_TRADE_CHEATER_OTHER: 'Этот игрок - мошенник, он может продать вам контрабанду!',
    CANNOT_TRADE_ADMIN: 'Как администратор, вы не можете влиять на экономику.',
    CANNOT_TRADE_ADMIN_OTHER: 'Игрок является администратором и с ним нельзя торговать.',
    DONT_THINK_GO_IN: 'Я не думаю, что мне стоит туда идти...',
    ENTERED_LOBBY: 'Вы вошли в лобби {{name}}.',
    EXITED_LOBBY: 'Вы покинули лобби {{name}}.',
    IN_PVP_ZONE: 'Вы вошли в зону PvP!',
    INVALID_AMOUNT: 'Вы ввели недопустимую сумму.',
    DOOR_KEY_CRUMBLES: 'Ключ рассыпается в пыль, когда вы проходите через дверь.',
    MINIMUM_PLAYERS_MINIGAME: 'Для начала этой мини-игры должно быть не менее {{minimum}} игроков.',
    NEED_COMBAT: 'Для использования этой способности необходимо находиться в бою.',
    NEED_WAIT_ABILIY:
        'Перед повторным использованием этой способности необходимо подождать {{duration}} секунд.',
    NO_IDEA: 'Я понятия не имею, что это такое.',
    NO_ARROWS: 'У вас нет стрел для стрельбы.',
    NO_ACHIEVEMENT_DOOR:
        'Чтобы пройти через эту дверь, необходимо выполнить достижение {{achievement}}.',
    NO_COMBAT_DOOR: 'Ваш боевой уровень должен быть не ниже {{level}}, чтобы войти.',
    NO_QUEST_DOOR: 'Чтобы пройти через эту дверь, необходимо выполнить квест {{quest}}.',
    NO_KEY_DOOR: 'У вас нет ключа, необходимого для прохода через эту дверь.',
    NO_SKILL_DOOR: 'Ваш {{skill}} должен быть не ниже {{level}}, чтобы войти.',
    NO_KNOWLEDGE_USE: 'Вы не обладаете достаточными знаниями, чтобы использовать это.',
    NO_SPACE: 'В инвентаре не хватает места.',
    NO_SPACE_OTHER: 'У другого игрока недостаточно места в инвентаре.',
    NO_SPACE_PET: 'У вас недостаточно места в инвентаре питомца.',
    NOT_IN_PVP_ZONE: 'Вы больше не находитесь в зоне PvP!',
    NOT_ONLINE: 'Игрок @aquamarine@{{username}}@crimson@ не в сети.',
    NOT_ENOUGH_MANA: 'У вас недостаточно маны для использования этой способности.',
    PLEASE_MAKE_ROOM_REWARD:
        'Пожалуйста, освободите место в своем инвентаре, чтобы принять эту награду',
    POISONED: 'Вы были отравлены!',
    POISON_WORN_OFF: 'Яд выветрился.',
    PLEASE_REPORT_BUG: 'Произошла ошибка, пожалуйста, сообщите об этом как об ошибке.',
    FREEZE_IMMUNITY:
        'Теперь вы невосприимчивы к эффектам замораживания в течение {{duration}} секунд.',
    FREEZE_IMMUNITY_WORN_OFF: 'Ваш иммунитет к эффектам замораживания ослаб.',
    FIRE_IMMUNITY: 'Теперь вы невосприимчивы к эффектам огня в течение {{duration}} секунд.',
    FIRE_IMMUNITY_WORN_OFF: 'Ваш иммунитет к эффектам огня ослаб.',
    FRIENDS_USERNAME_TOO_LONG: 'Это имя пользователя слишком длинное.',
    FRIENDS_ADD_SELF: `Послушайте, я понимаю, вам одиноко. Но вы не можете добавить себя в список друзей.`,
    FRIENDS_ALREADY_ADDED: 'Этот игрок уже находится в списке ваших друзей.',
    FRIENDS_USER_DOES_NOT_EXIST: 'Игрока с таким именем пользователя не существует.',
    FRIENDS_NOT_IN_LIST: 'Этого игрока нет в вашем списке друзей.',
    PEOPLE_ONLINE: 'В настоящее время в сети находится {{population}} человек.',
    SKILL_LEVEL_UP: 'Повышение уровня мастерства!',
    SKILL_LEVEL_UP_DESC: 'Поздравляем, ваше {{name}} достигло уровня {{level}}!',
    JAILED: 'В настоящее время вы находитесь в тюрьме на {{duration}}.',
    MUTED: 'В данный момент вы в муте.',
    LOW_MANA: 'Если у вас мало маны, ваши атаки будут слабее.',
    TRADE_REQUEST: 'Вы запросили торговлю с {{username}}.',
    TRADE_REQUEST_OTHER: '{{username}} запросил торговлю с вами.',
    TRADE_EMPTY: `Йо, почему вы ничего не торгуете?`,
    TRADE_COMPLETE: 'Благодарим Вас за использование торговой системы Kaetram!',
    WELCOME: 'Добро пожаловать в {{name}}!',
    WELCOME_BACK: 'С возвращением в {{name}}!',
    WHY_GO_THERE: 'Погодите, зачем мне туда идти?'
} as const;
